import { populate } from "populate";

const raw = {
  handleResize: true,
  width: 0,
  height: 0,
  x: 0,
  y: 0,
  list: [
    {
      id: "1",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "2",
      type: "Container",
      name: "backgrounds",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "3",
      type: "Container",
      name: "nodesContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "4",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "5",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world6_1",
      parent: "2",
      data: ""
    },
    {
      id: "7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2842,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world6_2",
      parent: "2",
      data: ""
    },
    {
      id: "8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5406,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world6_3",
      parent: "2",
      data: ""
    },
    {
      id: "9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8110,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world6_4",
      parent: "2",
      data: ""
    },
    {
      id: "10",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 370,
      y: 364,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "11",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 488,
      y: 405,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "12",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 562,
      y: 474,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "13",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 656,
      y: 508,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "14",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 757,
      y: 490,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "15",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 848,
      y: 448,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "16",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 936,
      y: 402,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "17",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1022,
      y: 343,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "18",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1119,
      y: 304,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "19",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1225,
      y: 304,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "20",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1309,
      y: 362,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "21",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1371,
      y: 436,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "22",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1435,
      y: 506,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "23",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1516,
      y: 565,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "24",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1622,
      y: 581,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "25",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1719,
      y: 536,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "26",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1771,
      y: 450,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "27",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1775,
      y: 335,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "28",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1788,
      y: 237,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "29",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1892,
      y: 187,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "30",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2011,
      y: 208,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "31",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2104,
      y: 257,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "32",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2187,
      y: 321,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "33",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2256,
      y: 408,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "34",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2335,
      y: 491,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "35",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2453,
      y: 532,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "36",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2564,
      y: 481,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "37",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2637,
      y: 399,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "38",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2699,
      y: 318,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "39",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2788,
      y: 264,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "40",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2894,
      y: 226,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "41",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3015,
      y: 229,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "42",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3102,
      y: 282,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "43",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3160,
      y: 354,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "44",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3227,
      y: 429,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "45",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3303,
      y: 507,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "46",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3395,
      y: 561,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "47",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3507,
      y: 591,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "48",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3616,
      y: 612,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "49",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3727,
      y: 582,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "50",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3784,
      y: 499,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "51",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3791,
      y: 401,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "52",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3788,
      y: 301,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "53",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3851,
      y: 226,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "54",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3948,
      y: 193,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "55",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4053,
      y: 212,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "56",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4151,
      y: 268,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "57",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4216,
      y: 348,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "58",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4279,
      y: 430,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "59",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4344,
      y: 518,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "60",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4432,
      y: 575,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "61",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4540,
      y: 567,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "62",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4625,
      y: 500,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "63",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4716,
      y: 440,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "64",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4820,
      y: 402,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "65",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4926,
      y: 383,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "66",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5038,
      y: 349,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "67",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5147,
      y: 327,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "68",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5247,
      y: 293,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "69",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5357,
      y: 284,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "70",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5472,
      y: 296,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "71",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5580,
      y: 333,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "72",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5671,
      y: 384,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "73",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5770,
      y: 442,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "74",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5883,
      y: 446,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "75",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5987,
      y: 406,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "76",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6080,
      y: 345,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "77",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6169,
      y: 282,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "78",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6268,
      y: 224,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "79",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6368,
      y: 191,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "80",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6479,
      y: 187,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "81",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6571,
      y: 240,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "82",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6610,
      y: 330,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "83",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6638,
      y: 426,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "84",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6691,
      y: 517,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "85",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6796,
      y: 538,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "86",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6911,
      y: 527,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "87",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7012,
      y: 473,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "88",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7086,
      y: 396,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "89",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7160,
      y: 322,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "90",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7231,
      y: 246,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "91",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7334,
      y: 198,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "92",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7445,
      y: 200,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "93",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7550,
      y: 229,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "94",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7648,
      y: 272,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "95",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7728,
      y: 326,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "96",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7792,
      y: 406,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "97",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7849,
      y: 478,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "98",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7947,
      y: 513,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "99",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8050,
      y: 509,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "100",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8167,
      y: 469,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "101",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8269,
      y: 384,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "102",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8351,
      y: 303,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "103",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8472,
      y: 246,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "104",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8601,
      y: 260,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "105",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8705,
      y: 325,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "106",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8738,
      y: 411,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "107",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8756,
      y: 505,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "108",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8806,
      y: 592,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "109",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8907,
      y: 622,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "110",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9019,
      y: 606,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "111",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9133,
      y: 571,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "112",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9243,
      y: 508,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "113",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9251,
      y: 385,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "114",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9225,
      y: 279,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "115",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9307,
      y: 207,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "116",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9412,
      y: 169,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "117",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9522,
      y: 169,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "118",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9642,
      y: 199,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "119",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9738,
      y: 269,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "120",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9750,
      y: 381,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "121",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9719,
      y: 492,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "122",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9755,
      y: 584,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "123",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9860,
      y: 628,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "124",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9987,
      y: 588,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "125",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10076,
      y: 524,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "126",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10166,
      y: 456,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "127",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10269,
      y: 403,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "128",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10365,
      y: 369,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "129",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10479,
      y: 338,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "130",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "203",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "253",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "294",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "353",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "414",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "509",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "542",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "199",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "249",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "290",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "349",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "410",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "505",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "538",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "567",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "131",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1710,
      y: 30,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "132",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 750,
      y: 40,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "133",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1570,
      y: 40,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "134",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 880,
      y: 50,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "135",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1430,
      y: 50,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "136",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1290,
      y: 60,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "137",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1020,
      y: 70,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "138",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1150,
      y: 70,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "139",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1630,
      y: 80,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "140",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 670,
      y: 90,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "141",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1490,
      y: 90,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "142",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 800,
      y: 100,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "143",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1350,
      y: 100,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "144",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1210,
      y: 110,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "145",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 940,
      y: 120,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "146",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1070,
      y: 120,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "147",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1720,
      y: 120,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "148",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1550,
      y: 130,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "149",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1410,
      y: 140,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "150",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 720,
      y: 150,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "151",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1270,
      y: 150,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "152",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1130,
      y: 160,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "153",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 860,
      y: 170,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "154",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 990,
      y: 170,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "155",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1640,
      y: 170,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "156",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1470,
      y: 180,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "157",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1330,
      y: 190,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "158",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1190,
      y: 200,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "159",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1050,
      y: 210,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "160",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 780,
      y: 220,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "161",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 910,
      y: 220,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "162",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1560,
      y: 220,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "163",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 970,
      y: 260,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "164",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 830,
      y: 270,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "165",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1480,
      y: 270,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "166",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 890,
      y: 310,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "167",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1110,
      y: 480,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "168",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1170,
      y: 530,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "169",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1030,
      y: 540,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "170",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1230,
      y: 580,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "171",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1090,
      y: 590,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "172",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 520,
      y: 620,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "173",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1290,
      y: 630,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "174",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 620,
      y: 640,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "175",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1150,
      y: 640,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "176",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1010,
      y: 650,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "177",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 720,
      y: 660,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "178",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 450,
      y: 690,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "179",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1210,
      y: 690,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "180",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1070,
      y: 700,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "181",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 550,
      y: 710,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "182",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 930,
      y: 710,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "183",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 650,
      y: 730,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "184",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1230,
      y: 580,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "185",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1050,
      y: 810,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "186",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1130,
      y: 750,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "187",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 380,
      y: 760,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "188",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 990,
      y: 760,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "189",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 480,
      y: 780,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "190",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 580,
      y: 800,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "191",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1190,
      y: 800,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "192",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1270,
      y: 740,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "193",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1350,
      y: 680,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "194",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1330,
      y: 790,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "195",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1410,
      y: 730,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "196",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1470,
      y: 780,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "197",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1550,
      y: 740,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_2",
      parent: "130",
      data: ""
    },
    {
      id: "198",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1610,
      y: 790,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_3",
      parent: "130",
      data: ""
    },
    {
      id: "204",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1835,
      y: 670,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "205",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1892,
      y: 563,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "206",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1952,
      y: 413,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "207",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2020,
      y: 472,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "208",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2087,
      y: 541,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "209",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2372,
      y: 296,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "210",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1956,
      y: 505,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "211",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2018,
      y: 567,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "212",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2494,
      y: 321,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "213",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2116,
      y: 595,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "214",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2079,
      y: 667,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "215",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1919,
      y: 701,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "216",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1870,
      y: 755,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "217",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1974,
      y: 758,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "218",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2069,
      y: 757,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "219",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1972,
      y: 631,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "220",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2173,
      y: 758,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "221",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2200,
      y: 671,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "222",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2262,
      y: 726,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "223",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2351,
      y: 758,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "224",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2321,
      y: 664,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "225",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2249,
      y: 587,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "226",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2176,
      y: 518,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "227",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2109,
      y: 461,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "228",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2036,
      y: 386,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "229",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2443,
      y: 269,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "230",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2415,
      y: 170,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "231",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2285,
      y: 140,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "232",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2222,
      y: 73,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "233",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2169,
      y: 43,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "234",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2163,
      y: 115,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "235",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2230,
      y: 183,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "236",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2336,
      y: 216,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "237",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2337,
      y: 88,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "238",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2429,
      y: 86,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "239",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2519,
      y: 77,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "240",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2810,
      y: 114,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "241",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2587,
      y: 126,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "242",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2725,
      y: 188,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "243",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2732,
      y: 66,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "244",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2679,
      y: 114,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "245",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2624,
      y: 56,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "246",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2636,
      y: 213,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "247",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2509,
      y: 164,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "248",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2553,
      y: 243,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_5",
      parent: "203",
      data: ""
    },
    {
      id: "254",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3128,
      y: 44,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "255",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3623,
      y: 63,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "256",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3280,
      y: 69,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "257",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3540,
      y: 70,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "258",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3743,
      y: 83,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "259",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3363,
      y: 90,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "260",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3857,
      y: 105,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "261",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3452,
      y: 114,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "262",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3782,
      y: 142,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "263",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3208,
      y: 149,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "264",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3591,
      y: 159,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "265",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3694,
      y: 185,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "266",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3410,
      y: 202,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "267",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3316,
      y: 211,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "268",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3508,
      y: 243,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "269",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3641,
      y: 252,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "270",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3355,
      y: 314,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "271",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3610,
      y: 326,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "272",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3441,
      y: 342,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "273",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3519,
      y: 388,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "274",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3050,
      y: 540,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "275",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2960,
      y: 580,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "276",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3190,
      y: 600,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "277",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2870,
      y: 630,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "278",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3100,
      y: 640,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "279",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2775,
      y: 690,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "280",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3010,
      y: 690,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "281",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3240,
      y: 700,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "282",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2915,
      y: 750,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "283",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3150,
      y: 750,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "284",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3380,
      y: 760,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "285",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3450,
      y: 790,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "286",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3055,
      y: 810,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "287",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3290,
      y: 810,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "288",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3360,
      y: 840,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "289",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3195,
      y: 870,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "253",
      data: ""
    },
    {
      id: "295",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4032,
      y: 383,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "296",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3938,
      y: 410,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "297",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5454,
      y: 455,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "298",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4018,
      y: 459,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "299",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5370,
      y: 461,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "300",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4130,
      y: 465,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "301",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5535,
      y: 483,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "302",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3922,
      y: 486,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "303",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5300,
      y: 490,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "304",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5358,
      y: 526,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "305",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4191,
      y: 538,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "306",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5447,
      y: 539,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "307",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4080,
      y: 545,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "308",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5531,
      y: 554,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "309",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5265,
      y: 560,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "310",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5621,
      y: 566,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "311",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5113,
      y: 575,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "312",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5190,
      y: 597,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "313",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4000,
      y: 615,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "314",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5444,
      y: 635,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "315",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3892,
      y: 636,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "316",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4154,
      y: 638,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "317",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5617,
      y: 641,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "318",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5337,
      y: 625,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "319",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5529,
      y: 644,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "320",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5264,
      y: 648,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "321",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5718,
      y: 652,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "322",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5906,
      y: 653,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "323",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6009,
      y: 653,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "324",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4248,
      y: 665,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "325",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5822,
      y: 665,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "326",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6107,
      y: 670,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "327",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5234,
      y: 722,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "328",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4056,
      y: 723,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "329",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3953,
      y: 734,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "330",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3815,
      y: 744,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "331",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5306,
      y: 750,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "332",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5395,
      y: 700,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "333",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5557,
      y: 735,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "334",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5470,
      y: 741,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "335",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6192,
      y: 756,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "336",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5653,
      y: 706,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "337",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5735,
      y: 748,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "338",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5821,
      y: 758,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "339",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6011,
      y: 758,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "340",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6093,
      y: 726,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "341",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4328,
      y: 759,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "342",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5944,
      y: 688,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "343",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4230,
      y: 767,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "344",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4138,
      y: 771,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "345",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3904,
      y: 802,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "346",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5620,
      y: 758,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "347",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5379,
      y: 757,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "348",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5902,
      y: 744,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_3",
      parent: "294",
      data: ""
    },
    {
      id: "354",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5819,
      y: 35,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "355",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6718,
      y: 35,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "356",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6094,
      y: 36,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "357",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5551,
      y: 38,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "358",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7328,
      y: 38,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "359",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6950,
      y: 51,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "360",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5400,
      y: 54,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "361",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7143,
      y: 56,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "362",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5701,
      y: 57,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "363",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5915,
      y: 58,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "364",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5640,
      y: 60,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "365",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6619,
      y: 74,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "366",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6019,
      y: 77,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "367",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6820,
      y: 81,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "368",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7218,
      y: 92,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "369",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7049,
      y: 93,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "370",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7272,
      y: 94,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "371",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6077,
      y: 97,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "372",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5467,
      y: 98,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "373",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6889,
      y: 104,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "374",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5551,
      y: 106,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "375",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5836,
      y: 106,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "376",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6692,
      y: 107,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "377",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6521,
      y: 114,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "378",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5950,
      y: 120,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "379",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7123,
      y: 131,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "380",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7202,
      y: 133,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "381",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5630,
      y: 145,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "382",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6598,
      y: 145,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "383",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6776,
      y: 148,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "384",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6981,
      y: 149,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "385",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5756,
      y: 156,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "386",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5895,
      y: 158,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "387",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6673,
      y: 178,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "388",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5828,
      y: 183,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "389",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5974,
      y: 185,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "390",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6866,
      y: 190,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "391",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7076,
      y: 191,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "392",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7133,
      y: 197,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "393",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6758,
      y: 210,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "394",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5678,
      y: 220,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "395",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6952,
      y: 226,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "396",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6691,
      y: 228,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "397",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5742,
      y: 250,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "398",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6841,
      y: 257,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "399",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7036,
      y: 264,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "400",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5797,
      y: 270,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "401",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6722,
      y: 278,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "402",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6928,
      y: 292,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "403",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6795,
      y: 317,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "404",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6996,
      y: 327,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "405",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6871,
      y: 342,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "406",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6940,
      y: 370,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "407",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6757,
      y: 377,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "408",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6890,
      y: 392,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "409",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6827,
      y: 404,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "353",
      data: ""
    },
    {
      id: "415",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7777,
      y: 46,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "416",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8072,
      y: 52,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "417",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7909,
      y: 56,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "418",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7705,
      y: 86,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "419",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7982,
      y: 93,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "420",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7840,
      y: 93,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "421",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7633,
      y: 117,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "422",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7946,
      y: 122,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "423",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7760,
      y: 139,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "424",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7887,
      y: 153,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "425",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7696,
      y: 162,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "426",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8008,
      y: 168,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "427",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7817,
      y: 180,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "428",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7938,
      y: 209,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "429",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8079,
      y: 213,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "430",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7762,
      y: 213,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "431",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8016,
      y: 247,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "432",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7863,
      y: 258,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "433",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7940,
      y: 296,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "434",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8063,
      y: 308,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "435",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8000,
      y: 358,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "436",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7487,
      y: 384,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "437",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7398,
      y: 402,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "438",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7319,
      y: 412,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "439",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7565,
      y: 426,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "440",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7455,
      y: 461,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "441",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7652,
      y: 465,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "442",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7261,
      y: 473,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "443",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7374,
      y: 476,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "444",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7526,
      y: 504,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "445",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7205,
      y: 528,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "446",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7317,
      y: 530,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "447",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7423,
      y: 530,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "448",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7609,
      y: 536,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "449",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7716,
      y: 538,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "450",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7261,
      y: 562,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "451",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7502,
      y: 574,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "452",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7662,
      y: 585,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "453",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7778,
      y: 590,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "454",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7160,
      y: 602,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "455",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7381,
      y: 609,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "456",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7580,
      y: 615,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "457",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7098,
      y: 626,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "458",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7315,
      y: 633,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "459",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7233,
      y: 636,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "460",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7724,
      y: 636,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "461",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7452,
      y: 645,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "462",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7872,
      y: 666,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "463",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7653,
      y: 671,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "464",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7806,
      y: 675,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "465",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7519,
      y: 683,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "466",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7028,
      y: 684,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "467",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8084,
      y: 692,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "468",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7963,
      y: 696,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "469",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7376,
      y: 704,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "470",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7273,
      y: 708,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "471",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7178,
      y: 711,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "472",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7460,
      y: 713,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "473",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7589,
      y: 716,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "474",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6867,
      y: 717,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "475",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6708,
      y: 730,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "476",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6961,
      y: 737,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "477",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8027,
      y: 737,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "478",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7096,
      y: 742,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "479",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7748,
      y: 745,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "480",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7919,
      y: 745,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "481",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7841,
      y: 748,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "482",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6795,
      y: 753,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "483",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7666,
      y: 754,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "484",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7322,
      y: 756,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "485",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7406,
      y: 757,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "486",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7232,
      y: 758,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "487",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7523,
      y: 758,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "488",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8152,
      y: 88,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "489",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8138,
      y: 165,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "490",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8202,
      y: 191,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "491",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8253,
      y: 232,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "492",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8201,
      y: 41,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "493",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8321,
      y: 81,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "494",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8452,
      y: 31,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "495",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8143,
      y: 257,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "496",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8404,
      y: 123,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "497",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8351,
      y: 198,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "498",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8300,
      y: 128,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "499",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8253,
      y: 86,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "500",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8540,
      y: 83,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "501",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8478,
      y: 127,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "502",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8141,
      y: 744,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "503",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8182,
      y: 664,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "504",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8230,
      y: 728,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_3",
      parent: "414",
      data: ""
    },
    {
      id: "510",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8938,
      y: 454,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "511",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9076,
      y: 387,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "512",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8894,
      y: 323,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "513",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9039,
      y: 266,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "514",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9150,
      y: 182,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "515",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8919,
      y: 186,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "516",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9037,
      y: 122,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "517",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9158,
      y: 63,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "518",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8950,
      y: 35,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "519",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8734,
      y: 821,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "520",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8872,
      y: 778,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "521",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9016,
      y: 813,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "522",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9153,
      y: 758,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "523",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9295,
      y: 803,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "524",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9274,
      y: 674,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "525",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9363,
      y: 553,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "526",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9361,
      y: 405,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "527",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9471,
      y: 487,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "528",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9587,
      y: 418,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "529",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9415,
      y: 722,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "530",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9482,
      y: 616,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "531",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9589,
      y: 536,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "532",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9571,
      y: 717,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "533",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9496,
      y: 833,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "534",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9660,
      y: 807,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "535",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9796,
      y: 762,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "536",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9918,
      y: 825,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "537",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9482,
      y: 350,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "509",
      data: ""
    },
    {
      id: "543",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9444,
      y: 64,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "542",
      data: ""
    },
    {
      id: "544",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9583,
      y: 124,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "542",
      data: ""
    },
    {
      id: "545",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9704,
      y: 53,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "542",
      data: ""
    },
    {
      id: "546",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9730,
      y: 175,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "542",
      data: ""
    },
    {
      id: "547",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9835,
      y: 271,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "542",
      data: ""
    },
    {
      id: "548",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9903,
      y: 361,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "542",
      data: ""
    },
    {
      id: "549",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9863,
      y: 502,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "542",
      data: ""
    },
    {
      id: "550",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9994,
      y: 444,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "542",
      data: ""
    },
    {
      id: "551",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10082,
      y: 347,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "542",
      data: ""
    },
    {
      id: "552",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9980,
      y: 256,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "542",
      data: ""
    },
    {
      id: "553",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9880,
      y: 152,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "542",
      data: ""
    },
    {
      id: "554",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9853,
      y: 33,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "542",
      data: ""
    },
    {
      id: "555",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10078,
      y: 176,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "542",
      data: ""
    },
    {
      id: "556",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10005,
      y: 88,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "542",
      data: ""
    },
    {
      id: "557",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10163,
      y: 89,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "542",
      data: ""
    },
    {
      id: "558",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10131,
      y: 759,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "542",
      data: ""
    },
    {
      id: "559",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10216,
      y: 646,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "542",
      data: ""
    },
    {
      id: "560",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10358,
      y: 566,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "542",
      data: ""
    },
    {
      id: "561",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10279,
      y: 758,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "542",
      data: ""
    },
    {
      id: "562",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10365,
      y: 683,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "542",
      data: ""
    },
    {
      id: "563",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10426,
      y: 803,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "542",
      data: ""
    },
    {
      id: "564",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10497,
      y: 714,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "542",
      data: ""
    },
    {
      id: "565",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10482,
      y: 603,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "542",
      data: ""
    },
    {
      id: "566",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10594,
      y: 808,
      anchor: {
        x: 0.48,
        y: 0.93
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_3",
      parent: "542",
      data: ""
    },
    {
      id: "200",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 900,
      y: 157,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "199",
      data: ""
    },
    {
      id: "250",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2050,
      y: 550,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "249",
      data: ""
    },
    {
      id: "291",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3505,
      y: 180,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "290",
      data: ""
    },
    {
      id: "350",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4080,
      y: 570,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "349",
      data: ""
    },
    {
      id: "411",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6820,
      y: 240,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "410",
      data: ""
    },
    {
      id: "506",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7500,
      y: 520,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "505",
      data: ""
    },
    {
      id: "539",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8977,
      y: 258,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "538",
      data: ""
    },
    {
      id: "568",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9923,
      y: 230,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "567",
      data: ""
    },
    {
      id: "201",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 20,
      y: 25,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 180,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "200",
      data: ""
    },
    {
      id: "202",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_harvest_map",
      parent: "200",
      data: ""
    },
    {
      id: "251",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "250",
      data: ""
    },
    {
      id: "252",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "tulip_harvest_map",
      parent: "250",
      data: ""
    },
    {
      id: "292",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 20,
      y: 25,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 180,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "291",
      data: ""
    },
    {
      id: "293",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.65,
        y: 0.65
      },
      angle: 5,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_harvest_map",
      parent: "291",
      data: ""
    },
    {
      id: "351",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "350",
      data: ""
    },
    {
      id: "352",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.65,
        y: 0.65
      },
      angle: 5,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "calla_harvest_map",
      parent: "350",
      data: ""
    },
    {
      id: "412",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "411",
      data: ""
    },
    {
      id: "413",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_harvest_map",
      parent: "411",
      data: ""
    },
    {
      id: "507",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "506",
      data: ""
    },
    {
      id: "508",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "daffodil_harvest_map",
      parent: "506",
      data: ""
    },
    {
      id: "540",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "539",
      data: ""
    },
    {
      id: "541",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -29,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_harvest_map",
      parent: "539",
      data: ""
    },
    {
      id: "569",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "568",
      data: ""
    },
    {
      id: "570",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -29,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "peony_harvest_map",
      parent: "568",
      data: ""
    }
  ]
} as const;

export class WorldLayout6 {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  backgrounds: GameObject<PIXI.Container>;
  nodesContainer: GameObject<PIXI.Container>;
  cropsSectorA: (GameObject<PIXI.Container>)[];
  cropsSectorB: (GameObject<PIXI.Container>)[];
  signsSectorA: (GameObject<PIXI.Container>)[];
  signsSectorB: (GameObject<PIXI.Container>)[];

  constructor() {
    populate(this, raw);
  }
}
